export const AM = "am";
export const PM = "pm";
